// import enterpriseCy from '../components/enterpriseCy/enterpriseCyList.vue'
// import enterpriseCy from '../components/enterpriseCy/viewEnterpriseCy.vue'

export default [
    { 
        path: 'enterpriseCy/enterpriseCyList', 
        component: resolve => require(['@/components/enterpriseCy/enterpriseCyList'],resolve),
        name:'EnterpriseCyList',
        meta:{
            id:'650',
            node:'enterpriseCy',
            url:'enterpriseCyList',
        }
    },
    { 
        path: 'enterpriseCy/viewEnterpriseCy', 
        component: resolve => require(['@/components/enterpriseCy/viewEnterpriseCy'],resolve),
        name:'ViewEnterpriseCy',
        meta:{
            id:'651',
            node:'enterpriseCy',
            url:'viewEnterpriseCy',
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/enterpriseCy.js